import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export const ReviewPrompt = () => {
  const [open, setOpen] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [ok, setOk] = useState(true);
  useEffect(() => { api.get("/reviews/status").then((r) => setOpen(r.data.show)).catch(() => {}); }, []);
  const later = () => { api.post("/reviews/snooze").catch(() => {}); setOpen(false); };
  const send = async () => {
    try {
      await api.post("/reviews", { rating, comment, publish_ok: ok });
      toast.success(rating >= 4 ? "Thank you! Lindsay will see your review." : "Thank you, that really helps us improve.");
      setOpen(false);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && later()}>
      <DialogContent aria-describedby={undefined} className="max-w-md bg-card p-8" data-testid="review-prompt">
        <DialogTitle className="font-serif uppercase text-2xl text-navy">How's The Roots Club working for you?</DialogTitle>
        <p className="text-sm text-muted-foreground">You've been with us two weeks. A quick rating helps Lindsay make it better.</p>
        <div className="flex gap-1 my-2">{[1, 2, 3, 4, 5].map((n) => (
          <button key={n} onClick={() => setRating(n)} aria-label={`${n} stars`} data-testid={`review-star-${n}`}><Star className={`h-8 w-8 ${n <= rating ? "fill-sun text-sun" : "text-border"}`} /></button>
        ))}</div>
        <textarea rows={3} value={comment} onChange={(e) => setComment(e.target.value)} placeholder="What's been most useful? Anything missing?" data-testid="review-comment" className="w-full rounded-lg border border-input bg-white px-3 py-2 text-sm" />
        <label className="flex items-center gap-2 text-xs text-muted-foreground"><input type="checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} data-testid="review-publish-ok" />Lindsay can share my review (first name and business) on her website</label>
        <div className="flex justify-between mt-2">
          <button onClick={later} data-testid="review-later" className="text-sm text-muted-foreground">Maybe later</button>
          <button onClick={send} disabled={!rating} data-testid="review-submit" className="rounded-full bg-pinkb text-white px-6 py-2 text-sm disabled:opacity-50">Send review</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
